
import React from 'react'
import { ZaviramedCinematicHero } from '../animations/Animation1'

const Video = () => {
  return (
    <ZaviramedCinematicHero/>
  )
}

export default Video